import {
  GET_COLLECTION_PARTNERS,
  GET_USERS,
  GET_CASE_STATES,
  GET_CASE_TYPES,
  GET_CASE_ABORTION_REASONS,
  GET_WATERMARK_PROVIDERS,
  UPDATE_USER_AVATAR,
} from "@Types/actionTypes";

export function getCollectionPartners(data) {
  return {
    type: GET_COLLECTION_PARTNERS,
    payload: data,
  };
}

export function getWatermarkProviders(data) {
  return {
    type: GET_WATERMARK_PROVIDERS,
    payload: data,
  };
}

export function getCaseAbortionReasons(data) {
  return {
    type: GET_CASE_ABORTION_REASONS,
    payload: data,
  };
}

export function getUsers(data) {
  return {
    type: GET_USERS,
    payload: data,
  };
}

export function getCaseStates(data) {
  return {
    type: GET_CASE_STATES,
    payload: data,
  };
}

export function getCaseTypes(data) {
  return {
    type: GET_CASE_TYPES,
    payload: data,
  };
}

export function updateUserAvatar(avatarId) {
  return {
    type: UPDATE_USER_AVATAR,
    payload: avatarId,
  };
}
